import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FoodmenuapiService } from './foodmenuapi.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrlVegitation}api/`;

@Injectable({
  providedIn: 'root'
})
export class AddfoodmenuService {
  url: string;
  accessToken: any;
  token_type: any;
  token: string;
  excelContent: any;

  constructor(private apiService: FoodmenuapiService, private http: HttpClient) {

  }

  addFoodCourtMenu(body?: any): Observable<any> {
    return this.apiService.post(APIs.addFoodCourtMenu, body).pipe(map(response => {
      return response;
    }));
  }

  updateFoodCourtMenu(body?: any): Observable<any> {
    return this.apiService.post(APIs.updateFoodCourtMenu, body).pipe(map(response => {
      return response;
    }));
  }

}